import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGrammarTopics } from "./grammarService";
import "./GrammarTopicListPage.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicUrl = (url) => url?.replace(/\/api\/media-images\//, "/api/public/media-images/") ?? url;
const toImgSrc = (url) => !url ? "" : toPublicUrl(url.startsWith("http") ? url : `${BASE_ROOT}${url}`);

const GrammarTopicListPage = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const res = await fetchGrammarTopics({ page, size: 20, search: search || undefined });
    if (res.status === 200 && res.data?.status) {
      setTopics(res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      setTopics([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="gtl-shell">
      <Navbar />
      <div className="gtl-page">

        <div className="gtl-hero-banner">
          <span className="gtl-hero-tag">Study Hub</span>
          <h1 className="gtl-hero-title">Grammar</h1>
          <p className="gtl-hero-sub">Master English grammar with structured topics and clear explanations.</p>
          <div className="gtl-search-wrap">
            <span className="gtl-search-icon">🔍</span>
            <input
              className="gtl-search"
              type="text"
              placeholder="Search grammar topics..."
              value={search}
              onChange={(e) => { setPage(0); setSearch(e.target.value); }}
            />
          </div>
        </div>

        {totalItems > 0 && (
          <p className="gtl-count">{totalItems} topic{totalItems !== 1 ? "s" : ""}</p>
        )}

        {loading ? (
          <div className="gtl-state">
            <span className="gtl-spinner" />
            <p>Loading topics…</p>
          </div>
        ) : topics.length === 0 ? (
          <div className="gtl-state">
            <span style={{ fontSize: "2.5rem" }}>📭</span>
            <p>No grammar topics available yet.</p>
          </div>
        ) : (
          <div className="gtl-grid">
            {topics.map((t) => (
              <div key={t.id} className="gtl-card" onClick={() => navigate(`/study/grammar/${t.id}`)}>
                <div className="gtl-card-media">
                  {t.coverImageUrl
                    ? <img src={toImgSrc(t.coverImageUrl)} alt={t.title} className="gtl-card-img" />
                    : <span className="gtl-card-icon">{t.icon || "📘"}</span>}
                </div>
                <div className="gtl-card-body">
                  <h3 className="gtl-card-title">{t.title}</h3>
                  {t.description && <p className="gtl-card-desc">{t.description}</p>}
                  <div className="gtl-card-footer">
                    <span className="gtl-card-badge">{t.subTopicCount || 0} sub-topics</span>
                    <span className="gtl-card-arrow">→</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="gtl-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
            <span>{page + 1} / {totalPages}</span>
            <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default GrammarTopicListPage;
